import { css } from '@mui/material';

export const useStyles = () => {
  return {
    searchInput: css`
      border-radius: 100px;
      input {
        padding: 2px 14px;
      }
    `,
    formControlSelect: css`
      width: 100%;
      margin-left: auto;
      margin-bottom: 15px;

      .MuiInputBase-formControl {
        border: 1px solid var(--grey200);
        border-radius: 100px;
        background: var(--white);
        height: 40px;
      }

      .MuiOutlinedInput-notchedOutline {
        border: 0;
      }

      .MuiInputBase-input {
        padding: 10px 16px;

        .select-circle {
          display: none;
        }
      }
    `,

    paperSelect: (isMulti: boolean) => css`
      border: 1px solid var(--grey200);
      background: var(--white);
      border-radius: 20px;
      box-shadow: none;

      .MuiMenu-list {
        padding: 12px;

        .MuiMenuItem-root,
        .MuiMenuItem-root:hover {
          padding: ${isMulti ? '0' : '4px 8px'};
          gap: 8px;
          border-radius: 8px;
          background: none;
          margin-bottom: ${isMulti ? '0' : '8px'};
        }

        .select-circle {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid var(--grey200);
          background: var(--white);

          svg {
            fill: var(--white);
            width: 16px;
          }
        }

        .Mui-selected,
        .Mui-selected:hover {
          background: ${isMulti ? 'none' : '#292929'};
          color: ${isMulti ? 'inherit' : 'var(--white)'};

          .select-circle {
            background: var(--primary);
          }
        }
      }
    `,
  };
};
